var map = {
	"./aberto.png": 3576,
	"./cintura.png": 9887,
	"./normal.png": 3138,
	"./pensativo.png": 4106,
	"./pensativo2.png": 2322,
	"./um.png": 2873,
	"./unhas.png": 9880
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9874;